<template>
  <div
    id="icons-search"
    class="form icons-search position-relative"
  >
    <div
      class="with-icon-before"
      style="--input-with-icon-color: var(--fa-navy); --input-border-color: var(--fa-navy)"
    >
      <font-awesome-icon
        :icon="$v6.solid.faMagnifyingGlass"
        style="line-height: 1"
      />
      <label
        for="icons-search"
        class="sr-only"
      >
        {{ label }}
      </label>
      <input
        id="icons-search"
        ref="searchTerm"
        name="icons-search"
        type="text"
        :value="term"
        :class="inputClass"
        :placeholder="`Search ${$counts.icons.all.formatted} icons...`"
        @input="inputChanged"
        @keyup.enter="(event) => $emit('go', event.currentTarget.value)"
        @focus="(event) => $emit('focus')"
        @blur="(event) => $emit('blur')"
      />
    </div>

    <span
      v-if="isShowingClearButton"
      class="icons-search-clear"
    >
      <button
        class="link size-lg margin-0 padding-y-2xs padding-x-xs"
        style="--button-color: var(--fa-gravy); --button-hover-color: var(--fa-red); --button-box-shadow-width: 0"
        aria-label="Clear Current Search"
        data-balloon-pos="up"
        @click.prevent="(event) => $emit('clear')"
      >
        <font-awesome-icon :icon="$v6.solid.faCircleXmark" />
      </button>
    </span>

    <span
      v-if="isShowingGoButton"
      class="icons-search-clear"
    >
      <button
        class="link size-lg margin-0 padding-y-2xs padding-x-xs"
        style="--button-color: var(--fa-gravy); --button-hover-color: var(--fa-dk-blue); --button-box-shadow-width: 0"
        aria-label="Search"
        data-balloon-pos="up"
        @click.prevent="(event) => $emit('go', term)"
      >
        <font-awesome-icon :icon="$v6.solid.faCircleArrowRight" />
      </button>
    </span>

    <powered-by-algolia v-if="isShowingPoweredBy" />
  </div>
</template>

<script>
  import { debounce, pick, without } from 'lodash'

  import PoweredByAlgolia from './PoweredByAlgolia'

  const DEBOUNCE_TIMER = 350

  export default {
    name: 'InputTerm',

    components: {
      PoweredByAlgolia
    },

    props: {
      term: {
        type: String
      },

      autoFocus: {
        type: Boolean,
        default: true
      },

      label: {
        required: true
      },

      isShowingClearButton: {
        type: Boolean,
        default: false
      },

      isShowingGoButton: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      allVersions() {
        let versions = []
        versions.push(this.$releases.latest.v6.version)
        versions.push(this.$releases.latest.v5.version)
        versions.push('All Versions')
        return versions
      },

      activeVersion() {
        return this.$releases.active.version
      },

      latestV6version() {
        return this.$releases.latest.v6.version
      },

      latestV5version() {
        return this.$releases.latest.v5.version
      },

      inputClass() {
        return ['rounded', { 'padding-right-10xl': this.isShowingPoweredBy }]
      },

      isShowingPoweredBy() {
        return !this.isShowingClearButton && !this.isShowingGoButton
      }
    },

    mounted() {
      if (this.autoFocus) {
        this.$nextTick(() => this.$refs.searchTerm.focus())
      }
    },

    methods: {
      resolveIconRoute(event) {
        const query = pick(this.$route.query, ['q', 'm', 's'])

        let routeParams = { name: 'versions' }
        let versionSelection = event.target.value.split('.')

        if (versionSelection[0] === '6') {
          routeParams.name = 'six.search'
          routeParams.query = query
        } else if (versionSelection[0] === '5') {
          routeParams.name = 'five.search'
          routeParams.query = { ...query, s: this.maybeRemoveThin(query.s) }
        }

        return window.location.replace(this.$router.resolve(routeParams).href)
      },

      maybeRemoveThin(style) {
        if (!style) {
          return undefined
        }
        const styles = style.split(',')

        return without(styles, 'thin').join(',')
      },

      inputChanged: debounce(function (event) {
        this.$emit('input', event.target.value)
      }, DEBOUNCE_TIMER)
    }
  }
</script>
